import React from "react";
import { Regular1Style } from "./css/Regular1Style";
import OutroLogo from "../../components/editor/Templates/OutroLogo";
import OutroText from "../../components/editor/Templates/OutroText";

const regular_1 = (props) => {
  console.log(props,'regularrrrrrrrrrrrrrrr')
  return (
    <Regular1Style>
      <div className="poster flex-column">
        <div className="logo-container flex-column">
          <OutroLogo logo={props.file} />
        </div>
        <div className="text-wrapper flex-column">
          <OutroText
            id={props.id}
            text={props.text}
            textStyle={props.textStyle}
            editStatus={props.editStatus}
            onInputSlideText={props.onInputSlideText}
          />
        </div>
      </div>
    </Regular1Style>
  );
};

export default regular_1;
